import { Button } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 100vh;
  padding: 24px;
  text-align: center;
  background-color: ${({ theme }) => theme.palette.white._250.hex()};
`;

export const Titulo = styled.h1`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.blue._950.hex()};
`;

export const Texto = styled.p`
  margin: 0;
  max-width: 520px;
  font-family: 'Quicksand', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.grey._720.hex()};
`;

export const SairButton = styled(Button)`
  && {
    margin-top: 8px;
    height: 40px;
    border-radius: 10px;
    text-transform: none;
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.white.main.hex()};
    background: ${({ theme }) =>
      `linear-gradient(180deg, ${theme.palette.blue._200.hex()} 0%, ${theme.palette.blue._850.hex()} 100%)`};
  }
`;
